import { Types } from "@ioc/types";
import { IHttpService } from "@modules/infra/http/models/IHttpService";
import { inject, injectable } from "inversify";
import { IProductBlockDTO } from "../dtos/IProductBlockDTO";
import { IProductBlockItensDTO } from "../dtos/IProductBlockItensDTO";
import { IProductBlockService } from "../models/IProductBlockService";
import { ISegmentsDTO } from "../dtos/ISegmentsDTO";

@injectable()
export class ProductBlockService implements IProductBlockService {
  // @ts-ignore
  @inject(Types.IHttpService) private httpInstance: IHttpService;

  public async execute(data: IProductBlockDTO): Promise<IProductBlockDTO> {
    const response = await this.httpInstance.post<IProductBlockDTO>(
      "product-block",
      data
    );
    return response;
  }

  public async getProduct(): Promise<IProductBlockDTO[]> {
    const response = await this.httpInstance.get("product-block");
    return response;
  }

  public async getProducts(): Promise<IProductBlockItensDTO[]> {
    const response = await this.httpInstance.get<
      { id: string; desc: string }[]
    >("product-block/products");
    return response.map((item) => ({ code: item.id, name: item.desc }));
  }

  public async getCenters(): Promise<IProductBlockItensDTO[]> {
    const response = await this.httpInstance.get<
      { id: string; desc: string }[]
    >("product-block/centers");
    return response.map((item) => ({ code: item.id, name: item.desc }));
  }

  public async getSegments(): Promise<ISegmentsDTO[]> {
    const response = await this.httpInstance.get("filters?action=SEGMENT");
    return response;
  }

  public async deleteProduct(
    productId: string,
    allowedSegments?: string[]
  ): Promise<IProductBlockDTO> {
    const response = await this.httpInstance.delete(
      `product-block/${productId}`,
      allowedSegments?.length ? { data: { allowedSegments } } : {}
    );
    return response;
  }
}
